/*============================================================================
Functions for mini cart
==============================================================================*/

$(document).ready(function() {
  function freeShippingLogic(cartTotalPrice, free_shipping_amount, progress_bar_percent) {
    if(cartTotalPrice >= free_shipping_amount) {
      console.log("Customer gets Free Shipping");
      $(".freeShippingNote").removeClass("hide");
      $(".notFreeShippingNote").addClass("hide");
      setTimeout(function() {
        $(".ajaxcart-progressbar-colored").css('width','100%');
      }, 200);
    }
    else {
      console.log("Show price left until free shipping");
      let price_left = free_shipping_amount - cartTotalPrice;

      $("#FS-amountLeft").html(Shopify.formatMoney(price_left, '' ));
      $(".freeShippingNote").addClass("hide");
      $(".notFreeShippingNote").removeClass("hide");
      setTimeout(function() {
        $(".ajaxcart-progressbar-colored").css('width', progress_bar_percent + '%'); 
      }, 200);
    }
  }

  /*
 * This is the main function that checks if the user gets Free Shipping or not.
 */ 
  function checkFreeShipping () {
    let free_shipping_amount = 9900;
    let cartTotalPrice;
    let new_progress_bar_percent;

    $.getJSON( "/cart.js", function( cart ) {
      cartTotalPrice = cart.total_price;
      new_progress_bar_percent = cartTotalPrice / (free_shipping_amount / 100);

      freeShippingLogic(cartTotalPrice, free_shipping_amount, new_progress_bar_percent);
    });
  }
  checkFreeShipping();
  
  function checkMinimumToCheckout() {
    $.getJSON( "/cart.js", function( cart ) {
      if(cart.total_price === 0) {
        $("#mini-cart .minimumToCheckoutMessage").removeClass("hide");
        $("#mini-cart .checkout").addClass("hide");
        $("#mini-cart .continue_shopping").addClass("hide");
      } else {
        $("#mini-cart .minimumToCheckoutMessage").addClass("hide");
        $("#mini-cart .checkout").removeClass("hide");
        $("#mini-cart .continue_shopping").removeClass("hide");
      }
    });
  }
  checkMinimumToCheckout();
  
  function updateCartHeight() {
    var checkoutButtonsHeight = $("#mini-cart .action.buttons").outerHeight() + 120;
    $("#mini-cart #cart_items").css({
      "max-height": `calc(100vh - ${checkoutButtonsHeight}px)`
    })
  }
  //updateCartHeight();

  // when the cart button is clicked
  // Show Drawer and overlay
  // Update Drawer Content
  function showCart(e) {
    if(e) e.preventDefault();
    $(".hc-cartDrawer").addClass("active");
    $(".cart-overlay").show();
    $("body").addClass("no-scroll");
  }
  
  function hideCart() {
    setTimeout(function() {
      $(".hc-cartDrawer").removeClass("active");
      $(".cart-overlay").hide();
      $("body").removeClass("no-scroll");
    }, 200)
  }
  
  $(document).on("click touchstart", "#CartButton", function(e) {
    showCart(e);
  });
  
  $(document).on("click touchstart", ".cart-overlay, .cart_close, .continue_shopping", function(e) {
    hideCart();
  });
  
  function updateCart() {
    
    fetch("/cart?view=json")
    .then(response => response.json())
    .then((data) => {
      var mini_cart = $("#mini-cart");
      var cart = data;
      $("#CartCount.cart-count").html(cart.item_count);
      
      // Hide quantity if the count is == 0
      cart.item_count != 0 ? $("#CartCount.cart-count").css({ display: "inline-block" }) : $("#CartCount.cart-count").hide()

      if(cart.total_saving > cart.total_price) {
        mini_cart.find(".you-are-saving").removeClass("hide").find(".money").html( Shopify.formatMoney( cart.you_are_saving ) )
        mini_cart.find("#totalBeforeSaving").removeClass("hide").find(".money").html( Shopify.formatMoney( cart.total_saving ) )
      } else {
        mini_cart.find(".you-are-saving").addClass("hide");
        mini_cart.find("#totalBeforeSaving").addClass("hide");
      }

      mini_cart.find(".subtotal .amount").html(Shopify.formatMoney(cart.total_price));

      checkFreeShipping();
      checkMinimumToCheckout();
      //updateCartHeight();
    });
  }
  
  function isItemInCart(variant_id) {
    var found = false;
    CartJS.cart.items.forEach(product => {
      if(product.variant_id === variant_id) {
        found = true;
      }
    });
    return found;
  }
  
  function addItemToCartDOM(item, isProductInCart) {
    var variant_options = "";
    item.options_with_values.forEach(function(option) {
      if(option.value.indexOf("Default Title") === -1) {
        variant_options += (`<span>${ option.name }: ${ option.value }</span>`);
      }
    });

    $.get( `${ item.url.split("?")[0] }.json`, function( data ) {
      data.product.variants.forEach(function(variant) {
        
        if(variant.id === item.id) {
          var compareAtPriceElement = "";
          var sale_badge = "";
          if(variant.compare_at_price != "" || variant.compare_at_price > 0) {
            compareAtPriceElement += `<span class="comparePrice"><s><strong>${ Shopify.formatMoney(variant.compare_at_price) }</strong></s></span>`;
            sale_badge += `<span class="sale_bg"></span>`
          }

          if(isProductInCart) {
            $(`.item-wrapper[data-variant-id="${ item.variant_id }"]`).find(".qty").text(`${ item.quantity }`);
          } else {
            $("#cart_items").prepend(
              `<div class="item-wrapper" data-variant-id="${ item.variant_id }">
                <div class="item-image">
                  <a href="${ item.url }">
          <img src="${ item.image }" />
          ${ sale_badge }
          </a>
                </div>

                <div class="item-title">
                  <div class="product-title">
                      <a href="${ item.url }">${ item.title }</a>
                  </div>

                  <div class="options">
                  ${ variant_options }
                  </div>

                  <div class="quantity float-left">
                    <span class="btn qty-minus qty-js" data-action="decrease">-</span>
                    <span class="qty">${ item.quantity }</span>
                    <span class="btn qty-plus qty-js" data-action="increase">+</span>
                  </div>
                </div>

                <div class="item-info">
                    <div class="item-price price">
                      ${ compareAtPriceElement }
                      ${ Shopify.formatMoney(item.final_price) }
          </div>    
                  <div class="removeItem">Remove</div>
                </div>
              </div>`
            );
          }
        }
      });
    })
    .done(function() {
      updateCart();
      showCart();
    })
  }
  
  function addItemToCart(variant_id, button) {
    var isProductInCart = isItemInCart(variant_id);
    CartJS.addItem(variant_id, 1, {}, {
      "success": function(data, textStatus, jqXHR) {
        console.log(textStatus);
        setTimeout(function() {
          addItemToCartDOM(data, isProductInCart);
          if(button) {
            button.attr("disabled", false)
          }
        }, 800);
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus);
      }
    });
  }
  
  function updateItemQuantity(variant_id, count) {
    CartJS.updateItemById(variant_id, count, {}, {
      "success": function(data, textStatus, jqXHR) {
        console.log(textStatus);
        setTimeout(function() {
          updateCart();
        }, 100);
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus);
      }
    });
  }
  
  function removeItemFromDOM(item, variant_id) {
    CartJS.removeItemById(variant_id, {
      "success": function(data, textStatus, jqXHR) {
        console.log(textStatus);
        setTimeout(function() {
          item.remove();
          updateCart();
          $(`#mini-cart .upsells [data-variant-id='${ variant_id }']`).removeClass("hide");
        }, 100);
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus);
      }
    });
  }
  
  
  $("#mini-cart").on("click", ".qty-plus", function() {
    var input = $(this).siblings(".qty");
    var currentVal = parseInt(input.text());
    var variant_id = parseInt( $(this).closest(".item-wrapper").data("variant-id") );
    
    if (!isNaN(currentVal)) {
      input.text(`${ currentVal + 1 }`);
    } else {
      input.text("0");
    }
    
    var count = parseInt(input.text());
    updateItemQuantity(variant_id, count)
  });

  $("#mini-cart").on("click", ".qty-minus", function() {
    var input = $(this).siblings(".qty");
    var currentVal = parseInt(input.text());
    var variant_id = parseInt( $(this).closest(".item-wrapper").data("variant-id") );
    var item = $(this).closest(".item-wrapper");

    if (!isNaN(currentVal) && currentVal > 0) {
      input.text(`${ currentVal - 1 }`);
      if (currentVal - 1 === 0) {
        removeItemFromDOM(item, variant_id);
        return true;
      }
    } else {
      input.text("0");
    }
    
    var count = parseInt(input.text());
    updateItemQuantity(variant_id, count)
  });

  $("#mini-cart").on("click", ".removeItem", function() {
    var item = $(this).closest(".item-wrapper");
    var variant_id = parseInt( $(this).closest(".item-wrapper").data("variant-id") );
    removeItemFromDOM(item, variant_id);
  });
  
  $("#mini-cart").on("click", ".upsell-action a", function(e) {
    e.preventDefault();
    var variant_id = parseInt( $(this).data("variant-id") );
    addItemToCart(variant_id);
    $(this).closest(".product").addClass("hide");
  });
  
  $(document).on("submit", "[action='/cart/add']", function(e) {
    e.preventDefault();
    var button = $(this).find("[type='submit']");
    var variant_id = parseInt( $(this).find("[name='id']").val() );
    
    button.attr("disabled", true);
    addItemToCart(variant_id, button);
  });
});